module.exports = __webpack_public_path__ + "static/media/interface.0302b963.svg";